<xcm-dynamic-view *ngIf="asset" [questions]="questions"></xcm-dynamic-view>